import React, {useEffect, useState} from "react";
import "./Header_Clothing.scss";
import {useHistory, useLocation} from "react-router-dom";
import {useBasket, useDispatchBasket} from "../../../../hooks";

function Header_Clothing() {

    const history = useHistory()
    const basket = useBasket();
    const setBasket = useDispatchBasket();
    const location = useLocation()
    const [merchantId,set_merchantId] = useState("")

    useEffect(()=>{
        let localbasket = getBasketFromLocal()
        if(localbasket){
            setBasket(localbasket)
        }
        let path = location.pathname.split("/")
        set_merchantId(path[2])
    },[])

    const calculateBasket = () => {
        let count = 0;
        basket.forEach(item => {
            count += item.count
        })
        return count
    }

    const getBasketFromLocal = ()=>{
        const localBasket = localStorage.getItem('basket');
        if(localBasket){
            return  JSON.parse(localBasket);
            // setBasket()
        }
        return false
    }

    return(
        <div className="header_clothing_container">
            <div className="bod">
                <img style={{padding:8}} src="/svg/left_sv.svg" alt="" onClick={()=>{
                    history.goBack()
                }} />
                <img src="/svg/clothing_brand.svg" alt=""/>
                <div className="clothing-basket-sec" onClick={()=>{
                    history.push(`/online-store-basket/${merchantId}`)
                }}>
                    <span className="clothing-basket-badg">{calculateBasket()}</span>
                    <img src="/svg/clothing_basket.svg" alt=""/>
                </div>
            </div>
        </div>
    )

}
export {Header_Clothing}
